import { watch, ref, onUnmounted } from 'vue'

import { useFormStore } from '@/stores/form'

const transactionReasonWatch = () => {
  const transactionReasonIdsWatch = ref()
  const formStore = useFormStore()

  transactionReasonIdsWatch.value = watch(
    () => formStore.form.values.transactionReasonIds,
    (newVal) => {}
  )
  onUnmounted(() => {
    transactionReasonIdsWatch.value && transactionReasonIdsWatch.value()
  })
}

const relationshipWatch = () => {
  const sponsorRelationshipIdWatch = ref()
  const formStore = useFormStore()

  sponsorRelationshipIdWatch.value = watch(
    () => formStore.form.values.sponsorRelationshipId,
    (newVal) => {}
  )
  onUnmounted(() => {
    sponsorRelationshipIdWatch.value && sponsorRelationshipIdWatch.value()
  })
}

export default function () {
  return {
    transactionReasonWatch,
    relationshipWatch
  }
}
